<template>
  <div id="app">
    <!-- Menu -->
    <MenuSeneca />
    <!-- Main content -->
    <router-view />
    <!-- Footer -->
    <FooterSeneca class="FooterSeneca" />
  </div>
</template>

<script>
import MenuSeneca from "@/components/MenuSeneca.vue";
import FooterSeneca from "@/components/FooterSeneca.vue";

export default {
  name: "App",
  components: {
    MenuSeneca,
    FooterSeneca,
  },
  provide() {
    return {
      siteTheme: this.siteTheme,
      menuItems: this.menuItems || [],
    };
  },
  data() {
    return {
      siteTheme: 'こころにゼロをとりもどせ',
      menuItems: [
        {
          id: 0,
          name: 'Home',
          ja: 'ホーム',
          link: '/',
          description: ''
        },
        {
          id: 1,
          name: 'About',
          ja: 'わたしたち',
          link: '/about',
          description: '私たちは一緒に伊豆大島に行っている学生時代の友人。このサイトは私たちがスクラッチで構築し運営している。'
        },
        {
          id: 2,
          name: 'Diary',
          ja: '日記',
          link: '/history',
          description: '日記。釣り合宿、集い、このサイトの作成裏、読んだ本、勉強したこと、作成したものなどなど。'
        },
        {
          id: 3,
          name: 'Gallery',
          ja: '写真',
          link: '/gallery',
          description: '綺麗な海、森、空の写真や魚の写真、このサイトの作成裏の写真など。写真は今後も追加していくつもりです。'
        },
        {
          id: 4,
          name: 'Villa',
          ja: '別荘計画',
          link: process.env.VUE_APP_S3_VILLA,
          description: '伊豆大島には近くて心地よい自然がある。人生で一度の絶景ではないかもしれないが、海の隔たりが日常と非日常をよく切り分けてくれる。大島に持った別荘で閑暇で観想的な生活をしたい。'
        }, {
          id: 5,
          name: 'slide',
          ja: 'Default',
          link: '/slide',
          description: 'Default'
        }
      ],
    };
  },
  watch: {
    $route(to) {
      // ページ遷移時にタイトルを更新
      document.title = `${this.siteTheme} - ${to.meta.title || "kokozero"}`;
    },
  },
  mounted() {
    // 初回のタイトル設定
    document.title = `${this.siteTheme} - ${this.$route.meta.title || "kokozero"}`;
  },

};
</script>

<style>
body,
html {
  margin: 0;
  padding: 0;
  height: 100%;
  /* ビューポート全体の高さを確保 */
  width: 100%;
  overflow: visible;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* ビューポート全体の高さを確保 */
  width: 100%;
  overflow-x: hidden;
}

#app>* {
  flex-shrink: 0;
  /* 子要素の高さを固定 */
  
}

router-view {
  flex-grow: 1;
  /* 中央のコンテンツが余ったスペースを埋める */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  /* コンテンツに余白を追加 */
  width: 100%;
}

.FooterSeneca {
  flex-shrink: 0;
  /* フッターの高さを固定 */
  width: 100%;
  z-index: 1000;
  text-align: center;
  padding: 10px 0;
  /* フッターの上下余白 */
}
</style>